<div class="mho-thanks">
    <div mat-dialog-title>
        <div>
            <h2 i18n>Remerciements</h2>
            <button mat-icon-button mat-dialog-close type="button" class="close-button">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <mat-dialog-content>
        <p>
            <ng-container i18n>Un grand merci à Renack, sans qui ni le script ni le site n'existeraient puisqu'il a fait tout le backend !</ng-container>
        </p>
        <p>
            <ng-container i18n>Merci aussi à Bigonoud, qui a accepté de mettre les mains dans le code pour nous aider au développement.</ng-container>
        </p>
        <p>
            <ng-container i18n>Merci à CrazyUnicorn, qui nous fait profiter de ses talents pour l'ergonomie du site.</ng-container>
        </p>
        <p>
            <ng-container i18n>Merci également aux traducteurs qui rendent l'internationalisation possible.</ng-container>
        </p>
        <p>
            <ng-container i18n>Merci à Argo qui a assuré à la perfection - assistée de Katt - le rôle de responsable des relations avec l'équipe de
                développement
                du jeu, et sans qui l'idée de faire du script un site ne serait pas née.
            </ng-container>
        </p>
        <p>
            <ng-container i18n>Merci enfin à aracime, notre plus grand et notre meilleur supporter, mais aussi à tous les membres du Théâtre Implacable qui ont
                testé et nous ont fait leurs retours sur les fonctionnalités.
            </ng-container>
        </p>
    </mat-dialog-content>
</div>
